import React, { Component } from 'react'
import '../styles/GlobalStyle.css'
import PersonAvatar from '../customcomponents/PersonAvatar'
import ColType from '../Types'
import { db } from '../firebase/Firebase'
import { Icon, Popover, Modal, Tooltip } from 'antd'
import { getColorGradient, getDOKLevelFromGrade, getStudentSurveysResults } from '../Util'
import { Document } from '../teacher/edvizv2/Edviz'
import DocumentDelegator from '../edviz/EdvizDelegator'
import StudentResource from '../teacher/pacingguide/StudentResource'
import ConditionalTooltip from '../customcomponents/ConditionalTooltip'


class DOKTeacherBreakdown extends Component {
    constructor(props) {
        super(props);

        this.studentResourceRef = React.createRef();

        this.state = {
            studentDict: {},
            questionDataDict: {},
            questionData: [],
            questionsMostIncorrect: [],
            questionsMostCorrect: [],
            studentsCompleted: 0,
            visible: false,
            viewingLessonPlanItem: null,
            viewingQuestionIdx: 0,
            standards: [],
            standardsDict: {},
            standardsBeingRetrieved: {},
        }
    }

    componentDidMount() {
        this.getStats()
        this.getStandards()
    }

    componentWillReceiveProps(nextProps) {
        this.getStats()
        this.getStandards()
    }

    getStandards = () => {
        if (!(this.props.quiz &&
            this.props.quiz.quiz &&
            this.props.quiz.quiz.hasOwnProperty('questionStandards') &&
            this.props.quiz.quiz.questionStandards)) {
            return;
        }

        let alreadyHaveStandards = true;
        for (let i = 0; i < this.props.quiz.quiz.questionStandards.length; i++) {
            const standard = this.props.quiz.quiz.questionStandards[i];
            if (!this.state.standardsDict.hasOwnProperty(standard)) {
                alreadyHaveStandards = false;
                break;
            }
        }
        if (alreadyHaveStandards) {
            return;
        }
        let alreadyRetrievingStandards = true;
        for (let i = 0; i < this.props.quiz.quiz.questionStandards.length; i++) {
            const standard = this.props.quiz.quiz.questionStandards[i];
            if (!this.state.standardsBeingRetrieved.hasOwnProperty(standard)) {
                alreadyRetrievingStandards = false;
                break;
            }
        }
        if (alreadyRetrievingStandards) {
            return;
        }

        let standardsBeingRetrieved = {}
        for (let i = 0; i < this.props.quiz.quiz.questionStandards.length; i++) {
            const standard = this.props.quiz.quiz.questionStandards[i];
            standardsBeingRetrieved[standard] = true;
        }
        this.setState({
            standardsBeingRetrieved: standardsBeingRetrieved,
        });

        //console.log('getting standards', this.props.quiz.quiz.questionStandards);

        let standardsPromises = [];
        let standards = [];
        let standardsDict = {};
        for (let i = 0; i < this.props.quiz.quiz.questionStandards.length; i++) {
            const standard = this.props.quiz.quiz.questionStandards[i];
            standardsPromises.push(new Promise((resolve, reject) => {
                db.collection(ColType.standards)
                    .where('standard', '==', standard)
                    .where('standardCategory', '==', this.props.quiz.quiz.standardCategory)
                    .where('standardName', '==', this.props.quiz.quiz.standardName)
                    .limit(1)
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            let fullStandard = doc.data();
                            if (!standardsDict.hasOwnProperty(standard)) {
                                standardsDict[standard] = fullStandard;
                                standards.push(fullStandard);
                            }
                        });
                        resolve();
                    })
                    .catch((error) => {
                        reject();
                    });
            }));
        }

        Promise.all(standardsPromises).then(() => {
            //console.log(standards, standardsDict);
            this.setState({
                standards: standards,
                standardsDict: standardsDict,
            });
        });
    }

    showModal = (lessonPlanItem, questionIdx) => {
        this.setState({
            visible: true,
            viewingLessonPlanItem: lessonPlanItem,
            viewingQuestionIdx: questionIdx,
        }, () => {
            if (this.studentResourceRef.current) {
                this.studentResourceRef.current.scrollToQuestion('Question ' + (questionIdx + 1));
            }
        });
    }

    hideModal = () => {
        this.setState({
            visible: false,
        })
    }

    studentDictHasAllStudents = (quiz) => {
        const studentIds = Object.keys(quiz.studentGrades)
        for (let i = 0; i < studentIds.length; i++) {
            const studentId = studentIds[i]
            if (!this.props.studentDict.hasOwnProperty(studentId)) {
                return false
            }
        }
        return true
    }

    numCompleted = (quiz) => {
        let count = 0
        Object.keys(quiz.studentGrades).map((studentId) => {
            if (!quiz.studentGrades.hasOwnProperty(studentId)) {
                return false
            }
            const studentGrade = quiz.studentGrades[studentId]
            if (studentGrade.graded) {
                count += 1
            }
            return false
        })
        return count
    }

    areChosenAnswersCorrect = (question, chosenAnswer) => {
        const questionAnswers = question.components[0].answers
        for (let answer of chosenAnswer.answer) {
            if (!questionAnswers[answer].correct) {
                return false
            }
        }
        return true
    }

    isChosenAnswerCorrect = (quiz, questionDoc, questionIdx, chosenAnswersBaseQuiz) => {
        //console.log('isChosenAnswerCorrect', quiz, questionDoc, questionIdx, chosenAnswersBaseQuiz)
        if (quiz.quiz.hasOwnProperty('version') &&
            (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0')) {
            return chosenAnswersBaseQuiz['' + questionIdx]
        }

        const uuid = questionDoc.metadata.uuid
        if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
            return false
        }
        const chosenAnswerBaseQuestionDocId = chosenAnswersBaseQuiz[uuid]
        for (let i = 0; i < questionDoc.components[0].answers.length; i++) {
            const answer = questionDoc.components[0].answers[i]
            if (answer.correct && answer.id === chosenAnswerBaseQuestionDocId) {
                return true
            }
        }
        return false
    }

    getStudentsInDOKLevel = (quiz, dokLevel) => {
        let students = []
        let studentsDict = {}
        if (!(quiz && dokLevel)) {
            return students
        }
        if (quiz.quiz.numQuestions === 0) {
            return students
        }
        let count = 0
        Object.keys(quiz.studentGrades).map((studentId) => {
            if (!quiz.studentGrades.hasOwnProperty(studentId)) {
                return false
            }
            const studentGrade = quiz.studentGrades[studentId]
            let assessmentCompleted = studentGrade.graded
            let highestDOKLevel = 1
            if (assessmentCompleted) {
                const finalGrade = studentGrade.finalGrade.grade * 100
                highestDOKLevel = getDOKLevelFromGrade(finalGrade)
            }
            if (highestDOKLevel !== dokLevel) {
                return false
            }
            if (highestDOKLevel === dokLevel && assessmentCompleted) {
                count += 1
                if (!studentsDict.hasOwnProperty(studentId)) {
                    studentsDict[studentId] = true
                    students.push(studentId)
                }
            }
            // dokLevel1 if not completed
            if (!assessmentCompleted && dokLevel === 1) {
                count += 1
                if (!studentsDict.hasOwnProperty(studentId)) {
                    studentsDict[studentId] = true
                    students.push(studentId)
                }
            }
            return false
        })

        return students
    }

    getAverageForQuestionUUID = (quiz, questionUUID) => {
        let students = []
        let studentsDict = {}
        if (!(quiz)) {
            return students
        }
        if (quiz.quiz.numQuestions === 0) {
            return students
        }
        let correctCount = 0
        let count = 0
        Object.keys(quiz.studentGrades).map((studentId) => {
            if (!quiz.studentGrades.hasOwnProperty(studentId)) {
                return false
            }
            const studentGrade = quiz.studentGrades[studentId]
            let assessmentCompleted = studentGrade.graded
            let highestDOKLevel = 1
            if (assessmentCompleted) {
                const finalGrade = studentGrade.finalGrade.grade * 100
                const chosenAnswersBaseQuiz = studentGrade.chosenAnswersBaseQuiz
                for (let i = 0; i < quiz.quiz.numQuestions; i++) {
                    const questionDoc = quiz.quiz.docs[i]
                    // const dokLevel = questionDoc.metadata.dokLevel
                    let uuid = ''
                    if (quiz.quiz.hasOwnProperty('version') &&
                        (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0')) {
                        uuid = '' + i
                    } else {
                        uuid = questionDoc.metadata.uuid
                    }

                    if (uuid !== questionUUID) {
                        continue
                    }

                    if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
                        continue
                    }
                    const correct = this.isChosenAnswerCorrect(quiz, questionDoc, i, chosenAnswersBaseQuiz)
                    if (correct) {
                        correctCount += 1
                    }
                    count += 1
                }
            }
            return false
        })

        if (correctCount === 0 || count === 0) {
            return '0.00'
        }
        return ((correctCount / count) * 100).toFixed(2)
    }

    getAverageForQuiz = (quiz) => {
        let students = []
        let studentsDict = {}
        if (!(quiz)) {
            return '100'
        }
        if (quiz.quiz.numQuestions === 0) {
            return '100'
        }
        let correctCount = 0
        let count = 0
        Object.keys(quiz.studentGrades).map((studentId) => {
            if (!quiz.studentGrades.hasOwnProperty(studentId)) {
                return false
            }
            const studentGrade = quiz.studentGrades[studentId]
            let assessmentCompleted = studentGrade.graded
            let highestDOKLevel = 1
            if (assessmentCompleted) {
                const finalGrade = studentGrade.finalGrade.grade * 100
                const chosenAnswersBaseQuiz = studentGrade.chosenAnswersBaseQuiz
                for (let i = 0; i < quiz.quiz.numQuestions; i++) {
                    const questionDoc = quiz.quiz.docs[i]
                    //const dokLevel = questionDoc.metadata.dokLevel
                    let uuid = ''
                    if (quiz.quiz.hasOwnProperty('version') &&
                        (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0')) {
                        uuid = '' + i
                    } else {
                        uuid = questionDoc.metadata.uuid
                    }
                    if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
                        continue
                    }
                    const correct = this.isChosenAnswerCorrect(quiz, questionDoc, i, chosenAnswersBaseQuiz)
                    if (correct) {
                        correctCount += 1
                    }
                    count += 1
                }
            }
            return false
        })

        if (correctCount === 0 || count === 0) {
            return '0.00'
        }

        return ((correctCount / count) * 100).toFixed(2)
    }

    getStats = () => {
        const quiz = this.props.quiz
        if (!quiz) {
            return
        }
        if (quiz.quiz.numQuestions === 0) {
            return
        }
        if (!(this.props &&
            this.props.studentDict)) {
            return
        }
        /*if (this.state.statsRetrieved) {
            return
        }
    
        this.setState({ statsRetrieved: true })*/

        let stats = {
            questionDataDict: {},
            questionData: [],
            questionsMostIncorrect: [],
            questionsMostCorrect: [],
            studentsCompleted: 0,
        }

        Object.keys(quiz.studentGrades).map((studentId) => {
            if (!this.props.studentDict.hasOwnProperty(studentId)) {
                return false
            }
            if (!quiz.studentGrades.hasOwnProperty(studentId)) {
                return false
            }
            const student = this.props.studentDict[studentId]
            const studentGrade = quiz.studentGrades[studentId]
            let assessmentCompleted = studentGrade.graded
            let highestDOKLevel = 1
            if (assessmentCompleted) {
                stats.studentsCompleted += 1
                const chosenAnswersBaseQuiz = studentGrade.chosenAnswersBaseQuiz
                for (let i = 0; i < quiz.quiz.numQuestions; i++) {
                    const questionDoc = quiz.quiz.docs[i]
                    let dokLevel = 1
                    if (!(quiz.quiz.hasOwnProperty('version') &&
                        (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0'))) {
                        dokLevel = questionDoc.metadata.dokLevel
                    }
                    let uuid = ''
                    if (quiz.quiz.hasOwnProperty('version') &&
                        (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0')) {
                        uuid = '' + i
                    } else {
                        uuid = questionDoc.metadata.uuid
                    }
                    if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
                        continue
                    }
                    const correct = this.isChosenAnswerCorrect(quiz, questionDoc, i, chosenAnswersBaseQuiz)
                    if (correct) {
                        const dokLevelNumber = parseInt(dokLevel, 10)
                        if (dokLevelNumber > highestDOKLevel) {
                            highestDOKLevel = dokLevelNumber
                        }
                    }

                    if (!stats.questionDataDict.hasOwnProperty(i)) {
                        stats.questionDataDict[i] = {
                            correct: 0,
                            incorrect: 0,
                            total: 0,
                        }
                    }
                    if (correct) {
                        stats.questionDataDict[i].correct += 1
                    } else {
                        stats.questionDataDict[i].incorrect += 1
                    }
                    stats.questionDataDict[i].total += 1
                }
            }
        })

        for (let i = 0; i < quiz.quiz.numQuestions; i++) {
            if (!stats.questionDataDict.hasOwnProperty(i)) {
                stats.questionData.push({
                    questionIndex: i,
                    correct: 0,
                    incorrect: 0,
                    total: 0,
                })
                continue
            }
            const questionData = stats.questionDataDict[i]
            stats.questionData.push({
                questionIndex: i,
                correct: questionData.correct,
                incorrect: questionData.incorrect,
                total: questionData.total,
            })
        }

        stats.questionsMostIncorrect = Object.assign([], stats.questionData).sort((a, b) => {
            return b.incorrect - a.incorrect
        })
        stats.questionsMostCorrect = Object.assign([], stats.questionData).sort((a, b) => {
            return b.correct - a.correct
        })

        this.setState({
            stats: stats,
            statsCompleted: true,
        })
    }

    getStudentView = (studentId) => {
        if (!(this.props.quiz &&
            this.props.studentDict &&
            studentId &&
            this.props.studentDict.hasOwnProperty(studentId))) {
            return false
        }
        const quiz = this.props.quiz
        const student = this.props.studentDict[studentId]
        if (!(student && quiz)) {
            return false
        }
        if (quiz.quiz.numQuestions === 0) {
            return false
        }
        if (!quiz.studentGrades.hasOwnProperty(student.id)) {
            return false
        }
        const studentGrade = quiz.studentGrades[student.id]
        let assessmentCompleted = studentGrade.graded
        if (this.props.hasOwnProperty('onlyShowCompleted') &&
            this.props.onlyShowCompleted &&
            !assessmentCompleted) {
            return false
        }
        return <tr key={'tr-' + student.id} style={{ borderBottom: '1px solid #eef2f7' }}>
            <td style={{ background: '#f8fafc' }}>
                <PersonAvatar
                    person={student}
                    size={'large'}
                    containerClassName="font-20"
                    avatarClassName="font-20 font-bold mr-2"
                    personClassName="font-black font-24 ellipsis"
                    personStyle={{ maxWidth: '220px' }}
                />
            </td>
            {this.props.hasOwnProperty('showProgress') && this.props.showProgress ?
                <td style={{ border: '1px solid #eef2f7' }}>
                    {assessmentCompleted ?
                        <div className='font-bold' style={{ color: '#389e0d' }}>
                            Completed
                        </div> :
                        <div className='font-bold' style={{ color: '#2d6a9f' }}>In progress</div>
                    }
                </td> : ''}
            {new Array(this.props.quiz.quiz.numQuestions).fill(0).map((mapQuestion, index) => {
                let question = this.props.quiz.quiz.docs[index]
                let allCorrect = false
                if (assessmentCompleted) {
                    let studentGrade = quiz.studentGrades[student.id]
                    if (studentGrade.hasOwnProperty('chosenAnswersBaseQuiz')) {
                        allCorrect = this.isChosenAnswerCorrect(this.props.quiz, question, index, studentGrade.chosenAnswersBaseQuiz)
                    }
                }
                let borderClasses = ' border-right border-top border-bottom'
                if (index === 0) {
                    borderClasses += ' border-left br-tl-4 br-bl-4'
                } else if (index === quiz.quiz.numQuestions - 1) {
                    borderClasses += ' br-tr-4 br-br-4'
                }
                return <td className={'results-table-question-cell'}
                    style={{
                        backgroundColor: assessmentCompleted ? allCorrect ? '#fff' : '#ffccc7' : '#fff',
                        border: '1px solid #eef2f7'
                    }}
                    key={'assessment-' + student.id + index}>
                    <div className='flex flex-v-center flex-h-center'>
                        {assessmentCompleted ?
                            allCorrect ?
                                <Icon type='check' className='font-bold' style={{ color: '#389e0d' }} /> :
                                <Icon type='close' className='font-bold' style={{ color: '#cf1322' }} /> :
                            <div className='text-center' style={{ width: '20px', color: '#94a3b8' }}>-</div>}
                        {/*<div className='ml-1'>{question.metadata.standard.standard}</div>*/}
                    </div>
                </td>
            })}
            <td style={{ background: '#f8fafc', fontWeight: 700, color: assessmentCompleted ? '#1e293b' : '#94a3b8' }}>{assessmentCompleted ? (quiz.studentGrades[student.id].finalGrade.grade * 100) + '%' : '-'}</td>
        </tr>
    }
    sortDOKStudents = (studentIds) => {
        if (!this.props.quiz) {
            return studentIds
        }
        return studentIds.sort((a, b) => {
            if (!this.props.quiz.studentGrades.hasOwnProperty(a) ||
                !this.props.quiz.studentGrades.hasOwnProperty(b)) {
                return 0
            }
            const studentAGrade = this.props.quiz.studentGrades[a].finalGrade.grade
            const studentBGrade = this.props.quiz.studentGrades[b].finalGrade.grade
            return studentAGrade - studentBGrade
        })
    }
    render() {
        return (
            <div className='relative'>
                {this.props.quiz && this.props.teacherRetakes && this.props.teachers ?
                    <div>
                        <table className='w-100 font-16 results-table' style={{ color: '#1e293b' }}>
                            <thead>
                                <tr>
                                    <th className='pl-2'
                                        style={{ borderRight: '1px solid transparent', background: '#eef2f7', color: '#1e293b', fontWeight: 800 }}
                                    >
                                        Name
                                    </th>
                                    {new Array(this.props.quiz.quiz.numQuestions).fill(0).map((mapLessonPlanItem, idx) => {
                                        let lessonPlanItem = null
                                        if (this.props.quiz.quiz.hasOwnProperty('version') &&
                                            (this.props.quiz.quiz.version === '3.0' ||
                                                this.props.quiz.quiz.version === '4.0')
                                        ) {
                                        } else {
                                            let lessonPlanItem = this.props.quiz.quiz.docs[idx]
                                        }
                                        let standard = ''
                                        let fullStandard = null
                                        if (this.props.quiz.quiz.hasOwnProperty('questionStandards') &&
                                            this.props.quiz.quiz.questionStandards &&
                                            idx < this.props.quiz.quiz.questionStandards.length) {
                                            if (this.props.quiz.quiz.questionStandards[idx] === 'highlight-text') {
                                                standard = (idx > 0 ? this.props.quiz.quiz.questionStandards[idx - 1] :
                                                    idx < this.props.quiz.quiz.questionStandards.length - 1 ?
                                                        this.props.quiz.quiz.questionStandards[idx + 1] : '');
                                            } else {
                                                standard = this.props.quiz.quiz.questionStandards[idx]
                                            }
                                            if (this.state.standardsDict.hasOwnProperty(standard)) {
                                                fullStandard = this.state.standardsDict[standard]
                                            }
                                        }
                                        return <ConditionalTooltip
                                            title={fullStandard ?
                                                'Question ' + (idx + 1) + ': Standard ' + standard + ' - ' + fullStandard.title :
                                                standard ? standard : undefined
                                            }
                                            placement={'bottom'}
                                            enabled={fullStandard}
                                        ><th className='results-table-question-cell cursor-pointer relative'
                                            onClick={(e) => {
                                                if (!(this.props.quiz.quiz &&
                                                    this.props.quiz.quiz.version &&
                                                    (this.props.quiz.quiz.version === '3.0' ||
                                                        this.props.quiz.quiz.version === '4.0')
                                                )) {
                                                    return;
                                                }
                                                if (!this.props.quiz.quiz.hasOwnProperty('questionStandards')) {
                                                    return;
                                                }
                                                this.showModal(lessonPlanItem, idx);
                                            }}
                                            title={this.props.quiz.quiz.hasOwnProperty('questionStandards') ?
                                                'Click to view question' : undefined}>
                                                <div className='pl-1'>
                                                    <div className='font-14 font-normal' style={{ color: '#94a3b8' }}>QUESTION {idx + 1}</div>
                                                    <div style={{ color: '#475569' }}>{lessonPlanItem ? lessonPlanItem.metadata.standard.standard : ''}</div>
                                                    {standard ?
                                                        <div style={{ color: '#475569' }}>{standard}</div>
                                                        : ''}
                                                </div>
                                            </th></ConditionalTooltip>
                                    })}
                                    <th style={{ paddingLeft: '22px', background: '#eef2f7', color: '#1e293b', fontWeight: 800 }}>Grade</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.teachers.map((teacher, teacherIndex) => {
                                    if (!this.props.teacherRetakes.hasOwnProperty(teacher.id)) {
                                        return false
                                    }
                                    return this.props.teacherRetakes[teacher.id].map((quiz, index) => {
                                        let studentSurveyResults = null;
                                        if (quiz.hasOwnProperty('studentSurveys') &&
                                            quiz.studentSurveys) {
                                            studentSurveyResults = getStudentSurveysResults(quiz.studentSurveys,
                                                quiz.hasOwnProperty('manualGrades') ? quiz.manualGrades : null
                                            );
                                        }
                                        return <tr style={{ borderBottom: '1px solid #eef2f7' }}>
                                            <td style={{ border: '1px solid #eef2f7', background: '#f8fafc' }}>
                                                <div>
                                                    <div className='flex flex-v-center'>
                                                        <PersonAvatar
                                                            person={quiz.teacher}
                                                            size={'large'}
                                                            containerClassName="font-16"
                                                            avatarClassName="font-16 font-bold mr-2"
                                                            personClassName="font-black font-16 ellipsis"
                                                            personStyle={{ maxWidth: '220px' }}
                                                        />
                                                        <div className='ml-1' style={{ color: '#475569' }}>#{index + 1}</div>
                                                    </div>
                                                    <div className='flex w-100 mt-1'>
                                                        <div className='font-16' style={{ color: '#475569' }}>
                                                            {this.numCompleted(quiz)} / {Object.keys(quiz.studentGrades).length} students completed this test
                                                        </div>
                                                    </div>
                                                    {studentSurveyResults ?
                                                        <div title={'Student responses to the question: How do you feel about this test?'}>
                                                            <div className='flex flex-v-center w-100'>
                                                                <div className='mr-2'>
                                                                    <div className='flex flex-v-center'>
                                                                        <div style={{ fontSize: '32px' }}>😀</div>
                                                                        <div className='font-16 ml-1' style={{ color: '#475569' }}>
                                                                            {(studentSurveyResults.goodPct * 100).toFixed(2) + '%'}
                                                                        </div>
                                                                    </div>
                                                                    <div className='br-4 overflow-hidden'
                                                                        style={{ width: '102px', height: '8px', background: '#e2e8f0' }}>
                                                                        <div className='background-green h-100'
                                                                            style={{ width: (studentSurveyResults.goodPct * 100).toFixed(2) + '%' }}></div>
                                                                    </div>
                                                                </div>
                                                                <div className='mr-2'>
                                                                    <div className='flex flex-v-center'>
                                                                        <div style={{ fontSize: '32px' }}>😐</div>
                                                                        <div className='font-16 ml-1' style={{ color: '#475569' }}>
                                                                            {(studentSurveyResults.somewhatGoodPct * 100).toFixed(2) + '%'}
                                                                        </div>
                                                                    </div>
                                                                    <div className='br-4 overflow-hidden'
                                                                        style={{ width: '102px', height: '8px', background: '#e2e8f0' }}>
                                                                        <div className='background-orange h-100'
                                                                            style={{ width: (studentSurveyResults.somewhatGoodPct * 100).toFixed(2) + '%' }}></div>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div className='flex flex-v-center'>
                                                                        <div style={{ fontSize: '32px' }}>☹️</div>
                                                                        <div className='font-16 ml-1' style={{ color: '#475569' }}>
                                                                            {(studentSurveyResults.notGoodPct * 100).toFixed(2) + '%'}
                                                                        </div>
                                                                    </div>
                                                                    <div className='br-4 overflow-hidden'
                                                                        style={{ width: '102px', height: '8px', background: '#e2e8f0' }}>
                                                                        <div className='background-red h-100'
                                                                            style={{ width: (studentSurveyResults.notGoodPct * 100).toFixed(2) + '%' }}></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''}
                                                </div>
                                            </td>
                                            {new Array(this.props.quiz.quiz.numQuestions).fill(0).map((mapLessonPlanItem, idx) => {
                                                let lessonPlanItem = null
                                                let uuid = ''
                                                if (quiz.quiz.hasOwnProperty('version') &&
                                                    (quiz.quiz.version === '3.0' ||
                                                        quiz.quiz.version === '4.0')
                                                ) {
                                                    uuid = '' + idx
                                                } else {
                                                    lessonPlanItem = quiz.quiz.docs[idx]
                                                    uuid = lessonPlanItem.metadata.uuid
                                                }
                                                const avgStr = this.getAverageForQuestionUUID(quiz, uuid)
                                                const avgNum = parseFloat(avgStr)
                                                let standard = ''
                                                let fullStandard = null
                                                if (this.props.quiz.quiz.hasOwnProperty('questionStandards') &&
                                                    this.props.quiz.quiz.questionStandards &&
                                                    idx < this.props.quiz.quiz.questionStandards.length) {
                                                    if (this.props.quiz.quiz.questionStandards[idx] === 'highlight-text') {
                                                        standard = (idx > 0 ? this.props.quiz.quiz.questionStandards[idx - 1] :
                                                            idx < this.props.quiz.quiz.questionStandards.length - 1 ?
                                                                this.props.quiz.quiz.questionStandards[idx + 1] : '');
                                                    } else {
                                                        standard = this.props.quiz.quiz.questionStandards[idx]
                                                    }
                                                    if (this.state.standardsDict.hasOwnProperty(standard)) {
                                                        fullStandard = this.state.standardsDict[standard]
                                                    }
                                                }
                                                return <ConditionalTooltip
                                                    title={fullStandard ?
                                                        'Question ' + (idx + 1) + ': Standard ' + standard + ' - ' + fullStandard.title :
                                                        standard ? standard : undefined
                                                    }
                                                    enabled={fullStandard}
                                                ><td className='purple-border-hover cursor-pointer'
                                                    style={{
                                                        border: '1px solid #eef2f7',
                                                        background: getColorGradient(avgNum)
                                                    }}
                                                    onClick={(e) => {
                                                        if (!(this.props.quiz.quiz &&
                                                            this.props.quiz.quiz.version &&
                                                            (this.props.quiz.quiz.version === '3.0' ||
                                                                this.props.quiz.quiz.version === '4.0')
                                                        )) {
                                                            return;
                                                        }
                                                        if (!this.props.quiz.quiz.hasOwnProperty('questionStandards')) {
                                                            return;
                                                        }
                                                        this.showModal(lessonPlanItem, idx);
                                                    }}
                                                    title={this.props.quiz.quiz.hasOwnProperty('questionStandards') ?
                                                        'Click to view question' : undefined}>
                                                        <div className='text-center'>
                                                            {avgStr}%
                                                        </div>
                                                    </td></ConditionalTooltip>
                                            })}
                                            <td className='text-center'
                                                style={{
                                                    border: '1px solid #eef2f7',
                                                    borderRight: 'none',
                                                    background: getColorGradient(parseFloat(this.getAverageForQuiz(quiz)))
                                                }}>
                                                {this.getAverageForQuiz(quiz)}%
                                            </td>
                                        </tr>
                                    })
                                })}
                            </tbody>
                        </table>
                        <Modal
                            title='View question'
                            width={1000}
                            visible={this.state.visible}
                            onCancel={this.hideModal}
                            footer={null}
                            forceRender={true}
                        >
                            <div>
                                {this.props.parentQuiz &&
                                    this.props.parentQuiz.version &&
                                    (this.props.parentQuiz.version === '3.0' ||
                                        this.props.parentQuiz.version === '4.0') ?
                                    <StudentResource
                                        ref={this.studentResourceRef}
                                        savedState={{ showAllCorrectAnswers: true, survey: 'good' }}
                                        htmlSource={this.props.parentQuiz.docs} />
                                    : ''}
                            </div>
                        </Modal>
                    </div>
                    : ''
                }
            </div>
        )
    }
}

export default DOKTeacherBreakdown
